import React from 'react'
import { StepperInterface } from '../../models/interfaces/stepper-item.interface';
import { StepperItem } from './../stepper';
import { MandatoryText } from './../text/mandatory-text';
import { SectionLoader } from '../loader';
import { P2TextDescription } from 'react-bootstrap-common-script';
interface SectionCardProps extends React.HTMLAttributes<HTMLDivElement>{
  titleChildren?:React.ReactNode,
  contentChildren?:React.ReactNode,
  activeStep?:number;
  stepperItems?:StepperInterface[];
  required?:boolean;
  disabled?:boolean;
  isLoading?:boolean;
  onClick?: () => void;
}

function SectionCard({isLoading=false, disabled=false, activeStep=1, required=true, stepperItems=[], onClick, style, ...props}:SectionCardProps) {
  return (
    <div className={`polymer_sectioncard ${props.className} ${disabled ? 'polymer_sectioncard__disabled' : ''}`} onClick={onClick} style={style}>
     {required && <MandatoryText style={{fontSize:"14px"}}/>}
      
      { activeStep <= stepperItems?.length && new Array(activeStep-1).fill(1).map((e,_index:number)=>{
          return <div key={stepperItems[_index]?.id}>
            <div style={{marginTop:_index > 0 ? -20 : 0}} className={`polymer_sectioncard__top polymer_sectioncard__top-completed `}>{
              <div style={{flex:1, display:'flex', flexDirection:"row", alignItems:"center"}}>
                <div style={{flex:1, display:'flex', flexDirection:"row", alignItems:"center", gap:10}}>
                  <StepperItem variant='section_completed' size={40}/>
                  <P2TextDescription title={stepperItems[_index]?.title} color="#085054" />
                </div>
                {/* <div style={{cursor: "pointer"}} onClick={() => {
                    if(stepperItems[_index]?.link){
                      navigate(stepperItems[_index].link!);
                    }
                }}>
                  <SectionCardEditIcon variant={"completed"}/>
                </div> */}
              </div>
            }</div>
            <div style={{height:20, borderLeft:3, borderRight:3, borderTop:0, borderBottom:0, borderStyle:'solid', borderColor:'#0C8188', backgroundColor:"#64C8C8"}}/>          </div>
        })}

      <div style={{marginTop:(activeStep > 1 && activeStep <= stepperItems?.length) ? -20 : 0}}>
        <div className={`polymer_sectioncard__top`}>
          <div style={{flex:1, display:'flex', flexDirection:"row", alignItems:"center", gap:10}}>
            {activeStep !== undefined && stepperItems.length > 0 && <StepperItem variant='section_active' size={40} step={activeStep.toString()}/>}
            {props.titleChildren}
          </div>
        </div>
        <div className={`polymer_sectioncard__bottom`}>
          {!isLoading && props.contentChildren}
          {isLoading && <SectionLoader/>}
        </div>
      </div>
    </div>
  )
}

export default SectionCard